module.exports = __webpack_public_path__ + "img/backpackBtn.21e589ab.png";